import React from 'react';
import { Link } from 'react-router-dom';
import { SiteNavLinks } from '../components/SiteNavLinks';
export function Shop() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-251" data-mp="3iy8evm295xra">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-252" data-mp="34ax59ppmsntt">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-253" data-mp="2zbk9ugkp28fm">
          lennon cripe
        </Link>

        <SiteNavLinks data-id="element-254" data-mp="3dzynlmjnfhay" />

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-255" data-mp="3e19mb7y8lyv7">
          contact
        </a>
      </header>

      {/* Shop content */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-256" data-mp="2li317qtjqg4d">
        <p className="lowercase" data-id="element-257" data-mp="2gl2t7ad4z3am">under maintenance</p>
      </section>
    </main>;
}